/* eslint-disable react/prop-types */
import React from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {UpdateOperationList} from '@/actions/setupActions';
import ProgressBar from '@/components/progressBar/Progresbar';
import {RECOVERY_PREPARATION_STATE} from '@/constants/enums';
import {isEqual} from '@/libs/appHelper';
import {consoleDebug} from '@/libs/consoleHelper';
import {formatMessage} from '@/libs/intlHelper';

import {
  ConvertStatusOperationsToUIOperations,
  ConvertSequeceNameLabel,
  CalculateOperationPercentage,
  CalculateOperationTimeRemaining,
} from './business/statusContent';
import {PRESSURIZED_CODE} from './constant/pressureContentConstant';
import {RUN_TIME_MODE, STATUS_SEQUENCE_DESINGER} from './constant/sequenceContentConstants';
// eslint-disable-next-line import/no-cycle
import SequenceDesigner from './SequenceDesigner';
import StatusService from './service/StatusService';

import './SequenceBuilder.less';

@connect((store) => ({
  isManualProfileRunning: store.setupStore.isManualProfileRunning,
  CustomOperation: store.setupStore.CustomOperation,
}))
class SequenceBuilder extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      indexCurrentRunning: -100,
      repeatOperations: {
        Repeat: 1,
        Repeated: 0,
      },
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {isManualProfileRunning, CustomOperation} = nextProps;

    if (isManualProfileRunning) {
      const UiOperations = [...CustomOperation.Operations];
      const StatusOperations = CustomOperation.TempOperations;
      const params = ConvertStatusOperationsToUIOperations(StatusOperations, UiOperations);
      const newOperations = params.operationsUI;
      const repeatOperations = {
        Repeat: CustomOperation.Repeat,
        Repeated: CustomOperation.Repeated,
      };
      let indexCurrentRunning = -100;

      switch (CustomOperation.Status) {
        case STATUS_SEQUENCE_DESINGER.DEPRESSURIZING:
          indexCurrentRunning = PRESSURIZED_CODE.DEPRESSURIZED.CODE;
          break;

        case STATUS_SEQUENCE_DESINGER.IDLE:
          indexCurrentRunning = -100;
          break;

        default:
          indexCurrentRunning = params.indexArrayRunning;
          break;
      }
      if (!isEqual(CustomOperation.Operations, newOperations)) nextProps.dispatch(UpdateOperationList(newOperations));
      return {
        ...prevState,
        indexCurrentRunning,
        repeatOperations,
      };
    }
    return {...prevState};
  }

  // eslint-disable-next-line consistent-return
  ProgressBarText = (operations, indextArray, repeatOperations) => {
    if (indextArray === -100)
      return formatMessage({
        id: 'manualProfile.progress.idle',
      });
    // eslint-disable-next-line consistent-return
    if (operations.length === 0) return;

    if (indextArray === PRESSURIZED_CODE.DEPRESSURIZED.CODE)
      return formatMessage({
        id: 'manualProfile.progress.depressurizing',
      });
    if (indextArray === PRESSURIZED_CODE.PRESSURIZED.CODE)
      return formatMessage({
        id: 'manualProfile.progress.pressurizing',
      });
    if (operations[indextArray] === undefined) return `undefined ${indextArray}`;

    switch (operations[indextArray].RecoveryPreparationState) {
      case RECOVERY_PREPARATION_STATE.POST_BUFFER_RECOVERY:
        return formatMessage({
          id: 'manualProfile.progress.postBufferRecovery',
        });
      case RECOVERY_PREPARATION_STATE.PRE_AIR_RECOVERY:
        return formatMessage({
          id: 'manualProfile.progress.preAirRecovery',
        });
      default:
        break;
    }
    switch (operations[indextArray].RepeatType) {
      case RUN_TIME_MODE.TIMES.VALUE:
        return `${ConvertSequeceNameLabel(operations[indextArray].Sequence)} - Run : ${
          operations[indextArray].Repeated
        } of ${operations[indextArray].Repeat} - Repeat : ${this.ConvertRepeatedValue(repeatOperations.Repeated)} of ${
          repeatOperations.Repeat
        }`;
      case RUN_TIME_MODE.MINUTES.VALUE:
        return `${ConvertSequeceNameLabel(operations[indextArray].Sequence)} - Run : ${CalculateOperationPercentage(
          operations[indextArray],
        )}% - ETR : ${CalculateOperationTimeRemaining(operations[indextArray])} - Repeat : ${this.ConvertRepeatedValue(
          repeatOperations.Repeated,
        )} of ${repeatOperations.Repeat}`;
      default:
        break;
    }
  };

  // eslint-disable-next-line class-methods-use-this
  ConvertRepeatedValue = (repeated) => {
    if (repeated === undefined) return -1;

    return repeated + 1;
  };

  CalcProgressbarPercentage = (operations) => {
    const {indexCurrentRunning} = this.state;
    const indexRunningArray = indexCurrentRunning;

    if (indexRunningArray < 0) return 0;

    const repeat = operations[indexRunningArray].Repeat;
    const repeated = operations[indexRunningArray].Repeated;

    return (repeated / repeat) * 100;
  };

  /**
   * @param {Object} response
   * @param {String} response.message
   */
  finishCallBack = (response) => {
    const {finishCallBack} = this.props;

    finishCallBack(response);
    this.setState({
      indexCurrentRunning: -100,
    });
  };

  render() {
    const {
      CustomOperation,
      isManualProfileRunning,
      onChangeOperations,
      changeViewMode,
      onChangeRepeatAll,
      depressurizeCallBack,
    } = this.props;
    const {repeatOperations, indexCurrentRunning} = this.state;

    const indexOperationsRunning = isManualProfileRunning ? indexCurrentRunning : -100;
    const progressBarText = this.ProgressBarText(
      [...CustomOperation.Operations],
      indexOperationsRunning,
      repeatOperations,
    );
    const progressPercentage = isManualProfileRunning
      ? this.CalcProgressbarPercentage([...CustomOperation.Operations])
      : 0;

    return (
      <>
        <div className="SequenceBuilder">
          <SequenceDesigner
            onChangeOperations={onChangeOperations}
            operations={[...CustomOperation.Operations]}
            changeViewMode={changeViewMode}
            repeatAll={CustomOperation.Repeat}
            onChangeRepeatAll={onChangeRepeatAll}
            defaulthPrimeParam={CustomOperation.DefaulthPrimeParam}
          />
        </div>

        <ProgressBar
          style={ProgressBar.styles.on_going}
          addingStyle=" progress-bar-text"
          width="850px"
          height="48px"
          progress={progressPercentage}
          label={progressBarText}
        />
        <StatusService
          finishCallBack={this.finishCallBack}
          depressurizeCallBack={depressurizeCallBack}
        />
      </>
    );
  }
}
// TODO: need to define the props derived structure
SequenceBuilder.propTypes = {
  onChangeOperations: PropTypes.func,
  finishCallBack: PropTypes.func,
  changeViewMode: PropTypes.func,
  onChangeRepeatAll: PropTypes.func,
  depressurizeCallBack: PropTypes.func,
};

SequenceBuilder.defaultProps = {
  /**
   * @param {*} response
   * @returns
   */
  onChangeOperations: (response) => consoleDebug('Sample output', response),
  /**
   * @param {*} response
   * @returns
   */
  finishCallBack: (response) => consoleDebug('Sample output', response),
  /**
   * @param {*} response
   * @returns
   */
  changeViewMode: (response) => consoleDebug('Sample output', response),
  /**
   * @param {*} response
   * @returns
   */
  onChangeRepeatAll: (response) => consoleDebug('Sample output', response),
  depressurizeCallBack: () => consoleDebug('Sample output'),
};

export default SequenceBuilder;
